import React, { useMemo } from 'react';
import moment from 'moment-timezone';
import PropTypes, { any } from 'prop-types';

import styles from './scheduleTab.scss';
import Img from '../../../../../components/Img';

const NextAvailableScheduleDay = (props) => {
    const {
        className,
        scheduleDay,
        eventSchedule,
        useEventTimeZone,
    } = props;

    const uniqueDrawTimes = useMemo(() => {
        return scheduleDay.draws.reduce((acc, draw) => {
            if (!acc.includes(draw.startDateTimeUtc)) {
                acc.push(draw.startDateTimeUtc);
            }

            return acc;
        }, []);
    }, [scheduleDay.draws]);

    const getFormattedScheduleDate = (date) => {
        if (date === null) {
            return 'Undated';
        }

        if (useEventTimeZone) {
            return moment.utc(date).tz(eventSchedule?.timeZone?.value).format('ddd, MMM, DD, yyyy');
        }

        return moment.utc(date).format('ddd, MMM, DD, yyyy');
    };

    return (
        <div className={`${styles.nextAvailableScheduleSection} ${className}`}>
            <div className={`${styles.applyFlex} ${styles.header}`}>
                <div className={`flex-1 ${styles.time}`}>
                    Time
                </div>
                <div className={`flex-1 ${styles.regStatus}`} data-testid="schedule.reg-status-header">
                    Reg
                </div>
                <div className={`flex-1 ${styles.drawTime}`}>
                    {getFormattedScheduleDate(scheduleDay.date)}
                </div>
                <div className={`flex-1 ${styles.facilities} ${styles.mrAuto}`}>
                    Facility
                </div>
            </div>
            <div className={styles.content}>
                {uniqueDrawTimes.map((drawTime) => {
                    return (
                        <div
                            key={`time-group-${drawTime}`}
                            className={`${styles.timeGroup}`}
                        >
                            {scheduleDay.draws.filter((draw) => draw.startDateTimeUtc === drawTime).map((draw, i) => {
                                return (
                                    <div
                                        key={`draw-${draw.id}`}
                                        className={`flex-1 mw0 mb4 ${styles.applyFlex}`}
                                    >
                                        <div className={`flex-1 ${styles.time}`}>
                                            {i === 0 && drawTime && moment.utc(drawTime).tz(eventSchedule?.timeZone?.value).format('hh:mm a')}
                                            {i === 0 && !drawTime && 'TBD'}
                                        </div>
                                        <div className={`flex-1 ${styles.regStatus}`} data-testid="schedule.reg-status">
                                            {draw.inDraw && (
                                                <Img className="ml8" src={'/img/v2/icons/icon-check-mark-green.svg'} data-testid="schedule.reg-status.checkmark" />
                                            )}
                                        </div>
                                        <div className={`flex-1 ${styles.drawTime}`}>
                                            {draw.name}
                                        </div>
                                        <div className={`flex-1 ${styles.facilities} ${styles.mrAuto}`}>
                                            {draw.clubLocationFacilityName}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

NextAvailableScheduleDay.propTypes = {
    className: PropTypes.string,
    scheduleDay: PropTypes.objectOf(any).isRequired,
    eventSchedule: PropTypes.objectOf(any).isRequired,
    useEventTimeZone: PropTypes.bool,
};

NextAvailableScheduleDay.defaultProps = {
    className: '',
    useEventTimeZone: false,
};

export default NextAvailableScheduleDay;
